// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import { registerControllers } from "@radioactive-labs/plutonium"
registerControllers(application)

import DwmSiteFilterController from "./dwm_site_filter_controller"
application.register("dwm-site-filter", DwmSiteFilterController)

import DwmViewToggleController from "./dwm_view_toggle_controller"
application.register("dwm-view-toggle", DwmViewToggleController)

import DwmSidebarController from "./dwm_sidebar_controller"
application.register("dwm-sidebar", DwmSidebarController)

import DwmStageTabsController from "./dwm_stage_tabs_controller"
application.register("dwm-stage-tabs", DwmStageTabsController)

import DwmModalController from "./dwm_modal_controller"
application.register("dwm-modal", DwmModalController)

import DwmHubFilterController from "./dwm_hub_filter_controller"
application.register("dwm-hub-filter", DwmHubFilterController)

import DwmJobSearchController from "./dwm_job_search_controller"
application.register("dwm-job-search", DwmJobSearchController)

import DwmGuidedJobSummaryController from "./dwm_guided_job_summary_controller"
application.register("dwm-guided-job-summary", DwmGuidedJobSummaryController)

import DwmFlashDismissController from "./dwm_flash_dismiss_controller"
application.register("dwm-flash-dismiss", DwmFlashDismissController)

import DwmPhotoPreviewController from "./dwm_photo_preview_controller"
application.register("dwm-photo-preview", DwmPhotoPreviewController)

import DwmFleetAssetTemplateController from "./dwm_fleet_asset_template_controller"
application.register("dwm-fleet-asset-template", DwmFleetAssetTemplateController)

import DwmWeatherPopoverController from "./dwm_weather_popover_controller"
application.register("dwm-weather-popover", DwmWeatherPopoverController)

import DwmPublicNavController from "./dwm_public_nav_controller"
application.register("dwm-public-nav", DwmPublicNavController)

import DwmPricingRailController from "./dwm_pricing_rail_controller"
application.register("dwm-pricing-rail", DwmPricingRailController)

import DwmPermissionMatrixController from "./dwm_permission_matrix_controller"
application.register("dwm-permission-matrix", DwmPermissionMatrixController)

import DwmTeamFilterController from "./dwm_team_filter_controller"
application.register("dwm-team-filter", DwmTeamFilterController)
